import React from "react";
import { defineMessages, useIntl } from "react-intl";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Icon, Button } from "@onelogin/react-components";

const messages = defineMessages({
  hideNoteDetails: {
    id: "hideNoteDetails",
    defaultMessage: "Hide note details"
  },
  deleteNote: {
    id: "deleteNote",
    defaultMessage: "Delete note"
  },
  shareNote: {
    id: "shareNote",
    defaultMessage: "Share note"
  },
  viewNote: {
    id: "viewNote",
    defaultMessage: "View note"
  }
});

const FunctionalButtonsHeader = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
`;

const StyledButton = styled(Button)`
  min-width: 30px !important;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FunctionalButtonsGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const ChevronIcon = styled(Icon).attrs({
  icon: "Chevron_left-16",
  size: "24"
})`
  cursor: pointer;
`;

const ShareIcon = styled(Icon).attrs({
  icon: "Person-Plus-24",
  size: "24"
})`
  cursor: pointer;
`;

const EyeIcon = styled(Icon).attrs({
  icon: "Eye-24",
  size: "24"
})`
  cursor: pointer;
`;

const TrashcanIcon = styled(Icon).attrs({
  icon: "Trashcan-24",
  size: "24"
})`
  cursor: pointer;
`;

const ShowNoteHeader = ({
  currentNote,
  isOwner,
  isEditor,
  isViewer,
  goBackToNotesList,
  onClickShare,
  onClickRemove,
  isContentVisible,
  onToggleMaskContent
}) => {
  const intl = useIntl();
  return (
    <FunctionalButtonsHeader>
      <StyledButton onClick={goBackToNotesList}>
        <ChevronIcon
          alt={intl.formatMessage(messages.hideNoteDetails)}
          data-testid="hide-note-button"
        />
      </StyledButton>

      <FunctionalButtonsGroup>
        <StyledButton onClick={() => onToggleMaskContent()}>
          <EyeIcon
            alt={intl.formatMessage(messages.viewNote)}
            data-testid="view-note-button"
          />
        </StyledButton>
        {isOwner && (
          <>
            <StyledButton onClick={() => onClickShare(currentNote.id)}>
              <ShareIcon
                alt={intl.formatMessage(messages.shareNote)}
                data-testid="share-note-button"
              />
            </StyledButton>
            <StyledButton
              onClick={event => onClickRemove(event, currentNote.id)}
            >
              <TrashcanIcon
                alt={intl.formatMessage(messages.deleteNote)}
                data-testid={`notepad-delete-${currentNote.id}-button`}
              />
            </StyledButton>
          </>
        )}
      </FunctionalButtonsGroup>
    </FunctionalButtonsHeader>
  );
};

ShowNoteHeader.propTypes = {
  currentNote: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }),
  goBackToNotesList: PropTypes.func.isRequired,
  onClickShare: PropTypes.func.isRequired,
  onClickRemove: PropTypes.func.isRequired
};

export default ShowNoteHeader;
